import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  keywords?: string;
  structuredData?: object;
}

export function SEOHead({
  title,
  description,
  canonical,
  ogImage = '/owl-logo.png',
  keywords,
  structuredData
}: SEOHeadProps) {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname.replace(/\/$/, '') || '/' : '/';
  const dynamicCanonical = `https://healthyowl.in${currentPath}`;
  const currentCanonical = canonical || dynamicCanonical;
  
  // In production, canonical is injected server-side to ensure it's in the initial HTML
  // Only render canonical client-side in development for testing
  const isProduction = typeof window !== 'undefined' && window.location.hostname === 'healthyowl.in';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Canonical Link - only in development, production uses server-side injection */}
      {!isProduction && <link rel="canonical" href={currentCanonical} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={currentCanonical} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
